export const fillLabelTemplate = (template: string, value: string, sign = '%s') => {
  const regexp = new RegExp(sign);

  return template.replace(regexp, value);
};
